class MCartDrawer extends HTMLElement {
    constructor() {
        super();
        this.cartDrawerInner = this.querySelector(".m-cart-drawer__inner");
        this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close");
        this.cartOverlay = this.querySelector(".m-cart__overlay");
        this.rootUrl = window.Shopify.routes.root;

        this.setHeaderCartIconAccessibility();
        this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this));
        this.addEventListener("click", (t) => {
            if (t.target.closest(".m-cart-drawer__inner") !== this.cartDrawerInner) {
                this.close();
            }
        });
    }

    setHeaderCartIconAccessibility() {
        document.querySelectorAll(".m-cart-icon-bubble").forEach((t) => {
            t.setAttribute("role", "button");
            t.setAttribute("aria-haspopup", "dialog");
            t.addEventListener("click", (e) => {
                if (MinimogSettings.enable_cart_drawer) {
                    e.preventDefault();
                    this.open(t);
                }
            });
        });
    }

    // async open(t) {
    //     if (t) {
    //         this.setActiveElement(t);
    //     }

    //     this.classList.add("m-cart-drawer--active");
    //     requestAnimationFrame(() => {
    //         this.style.setProperty("--m-bg-opacity", "0.5");
    //         this.cartDrawerInner.style.setProperty("--translate-x", "0");
    //     });
    //     window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);

    //     await this.sortCartItemsBySku();
    // }

      open(t) {
        if (t) {
            this.setActiveElement(t);
        }

        this.classList.add("m-cart-drawer--active");
        requestAnimationFrame(() => {
            this.style.setProperty("--m-bg-opacity", "0.5");
            this.cartDrawerInner.style.setProperty("--translate-x", "0");
        });
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer);
        
        // Not Needed
        // this.sortCartItemsBySku();
    }

    close() {
        this.style.setProperty("--m-bg-opacity", "0");
        this.cartDrawerInner.style.setProperty("--translate-x", "100%");
        setTimeout(() => {
            this.classList.remove("m-cart-drawer--active");
        }, 300);
    }

    renderContents(t) {
        if (this.classList.contains("m-cart--empty")) {
            this.classList.remove("m-cart--empty");
        }
        this.productId = t.id;
        this.getSectionsToRender().forEach((e) => {
            const element = e.selector ? document.querySelector(e.selector) : document.getElementById(e.id);
            element.innerHTML = this.getSectionInnerHTML(t.sections[e.id], e.selector);
        });

        setTimeout(() => {
            this.open();
            if (window.FoxKitV2 && window.FoxKitV2.Modules.InCart) {
                window.FoxKitV2.Modules.InCart.getCart();
            }
        });
    }

    updateCartCount(t) {
        document.querySelectorAll(".m-cart-count-bubble").forEach((e) => {
            if (t > 0) {
                e.textContent = t;
                e.classList.remove("hidden");
            } else {
                e.classList.add("hidden");
            }
        });
    }

    getCart() {
        return fetch(this.rootUrl + "cart.js").then((response) => response.json());
    }

    async onCartDrawerUpdate(t = true) {
        fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
            .then((t) => t.text())
            .then((e) => {
                this.getSectionsToRender().forEach((r) => {
                    const element = r.selector ? document.querySelector(r.selector) : document.getElementById(r.id);
                    if (r.block === "cart-items") {
                        element.innerHTML = this.getSectionInnerHTML(e, r.selector);
                        if (window.FoxKitV2 && window.FoxKitV2.Modules.InCart) {
                            window.FoxKitV2.Modules.InCart.getCart();
                        }
                    } else if (t) {
                        element.innerHTML = this.getSectionInnerHTML(e, r.selector);
                    }
                });
            })
            .catch((t) => {});

        this.getCart().then((t) => {
            this.classList.toggle("m-cart--empty", t.item_count === 0);
            this.updateCartCount(t.item_count);
        });

        console.log("Updated Cart and Sorting")
        // this.sortCartItemsBySku().then(result => console.log(result)).catch(e => console.log(e));
    }

    getSectionInnerHTML(t, e = ".shopify-section") {
        return (new DOMParser).parseFromString(t, "text/html").querySelector(e).innerHTML;
    }

    getSectionsToRender() {
        return [
            { id: "cart-drawer", selector: "[data-minimog-cart-items]", block: "cart-items" },
            { id: "cart-drawer", selector: "[data-minimog-cart-discounts]", block: "cart-footer" },
            { id: "cart-drawer", selector: "[data-cart-subtotal]", block: "cart-footer" },
            { id: "cart-drawer", selector: "[data-minimog-gift-wrapping]", block: "cart-footer" }
        ];
    }

    getSectionDOM(t, e = ".shopify-section") {
        return (new DOMParser).parseFromString(t, "text/html").querySelector(e);
    }

    setActiveElement(t) {
        this.activeElement = t;
    }

    async sortCartItemsBySku() {
        try {
            

            const response = await fetch("/cart.js");

            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }
            const json = await response.json();
            if(json.items.length > 0) {
                const loadingSpinner = this.querySelector(".m-cart-drawer__loading-spinner");

                // Show the loading spinner
                loadingSpinner.style.display = "flex";
                const sortedItems = json.items.sort((a, b) => {
                    const parseSku = (sku) => {
                        const cleanedSku = sku.replace(/[^a-zA-Z0-9]/g, '');
                        const match = cleanedSku.match(/^([a-zA-Z]*)(\d*)/);
                        return {
                            alpha: match[1] || '',
                            numeric: match[2] ? parseInt(match[2], 10) : 0
                        };
                    };
    
                    const skuA = parseSku(a.sku || '');
                    const skuB = parseSku(b.sku || '');
    
                    if (!skuA.alpha && skuB.alpha) return -1;
                    if (skuA.alpha && !skuB.alpha) return 1;
    
                    if (skuA.alpha !== skuB.alpha) {
                        return skuB.alpha.localeCompare(skuA.alpha);
                    }
    
                    return skuB.numeric - skuA.numeric;
                });
                
                // Removing Clear and Add since it can cause problems if the user is too fast
              
                console.log("Sorted items by SKU:", sortedItems);
                await fetch('/cart/clear.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                });
    
                if (!clearCartResponse.ok) {
                    throw new Error(`Clear Cart Response status: ${clearCartResponse.status}`);
                }
    
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: sortedItems })
                });
    
                if (!addItemsResponse.ok) {
                    throw new Error(`Failed to add items to cart. Status: ${addItemsResponse.status}`);
                }
                
    
                await fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`)
                .then((t) => t.text())
                .then((e) => {
                    this.getSectionsToRender().forEach((r) => {
                        const element = r.selector ? document.querySelector(r.selector) : document.getElementById(r.id);
                        if (r.block === "cart-items") {
                            element.innerHTML = this.getSectionInnerHTML(e, r.selector);
                            if (window.FoxKitV2 && window.FoxKitV2.Modules.InCart) {
                                window.FoxKitV2.Modules.InCart.getCart();
                            }
                        } else if (t) {
                            element.innerHTML = this.getSectionInnerHTML(e, r.selector);
                        }
                    });
                })
                .finally(() => {loadingSpinner.style.display = "none"})
                .catch((t) => {});
            }

        } catch (error) {
            console.error("Error sorting and adding items to cart:", error);
        }
    }




}

customElements.define("m-cart-drawer", MCartDrawer);

class MCartDrawerItems extends MCartTemplate {
    getSectionsToRender() {
        return [
            { id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-minimog-cart-items]" },
            { id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-minimog-cart-discounts]" },
            { id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-cart-subtotal]" },
            { id: "MinimogCartDrawer", section: "cart-drawer", selector: "[data-minimog-gift-wrapping]" }
        ];
    }
}

customElements.define("m-cart-drawer-items", MCartDrawerItems);
